var _radialGradient, _circle, _radialGradient2, _circle2, _radialGradient3, _circle3, _radialGradient4, _path, _radialGradient5, _path2, _radialGradient6, _path3, _circle4, _path4, _circle5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmilingFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "lekld~3GkdQe_M6i5SLraa",
    cx: 24,
    cy: 24,
    r: 18,
    fx: 23.905,
    fy: 16.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffd426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fdcd23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#f8b919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f09c0c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#lekld~3GkdQe_M6i5SLraa)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "lekld~3GkdQe_M6i5SLrab",
    cx: 36,
    cy: 29,
    r: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8400",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#ff8400",
    stopOpacity: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 29,
    r: 5,
    fill: "url(#lekld~3GkdQe_M6i5SLrab)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "lekld~3GkdQe_M6i5SLrac",
    cx: 12,
    cy: 29,
    r: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#ff8400",
    stopOpacity: 0
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 29,
    r: 5,
    fill: "url(#lekld~3GkdQe_M6i5SLrac)"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "lekld~3GkdQe_M6i5SLrad",
    cx: 23.988,
    cy: 29.43,
    r: 5.577,
    fx: 23.984,
    fy: 29.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe16e",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lekld~3GkdQe_M6i5SLrad)",
    d: "M24,33c-4.106,0-5.336-1.456-5.336-1.456S19.98,35,24,35l0-0.001V35 c4.02,0,5.336-3.456,5.336-3.456S28.106,33,24,33z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "lekld~3GkdQe_M6i5SLrae",
    cx: 24.046,
    cy: 31.778,
    r: 5.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#cc9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc9000",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lekld~3GkdQe_M6i5SLrae)",
    d: "M24,35c-3.51,0-5-2.767-5-2.767S20.058,37,24,37s5-4.767,5-4.767S27.51,35,24,35z"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "lekld~3GkdQe_M6i5SLraf",
    cx: -1287.463,
    cy: 28.913,
    r: 15.654,
    gradientTransform: "matrix(-.35 0 0 .1877 -426.596 26.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lekld~3GkdQe_M6i5SLraf)",
    d: "M19.299,30.805c-0.501-0.276-0.995,0.358-0.608,0.779C19.815,32.806,21.542,34,24,34 s4.185-1.194,5.309-2.416c0.387-0.421-0.107-1.055-0.608-0.779C27.55,31.441,25.976,32,24,32S20.45,31.441,19.299,30.805z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 24.5,
    r: 0.5,
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M27.742,24.939c0,0,1.726-0.944,3.258-0.944s3.258,0.944,3.258,0.944l0.631-0.754 c0,0-1.765-2.185-3.889-2.185s-3.889,2.185-3.889,2.185L27.742,24.939z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 24.5,
    r: 0.5,
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 24.5,
    r: 0.5,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M13.742,24.939c0,0,1.726-0.944,3.258-0.944s3.258,0.944,3.258,0.944l0.631-0.754 c0,0-1.765-2.185-3.889-2.185s-3.889,2.185-3.889,2.185L13.742,24.939z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 24.5,
    r: 0.5,
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilingFace);
export default __webpack_public_path__ + "static/media/smiling-face.9f8e76f31f078bc6148fe0439ee131c6.svg";
export { ForwardRef as ReactComponent };